import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import { Popover, Progress, Tooltip, message } from 'antd';
import { useLocation, useNavigate }from "react-router-dom"; 
import API from '@api/api.js';
import { AppContext, channel } from '@utils/AppContext';
import styles from './loggedHead.module.scss'
import CountUp from 'react-countup';
import eventBus from '@utils/eventBus';
import SwitchHomePageType from '../SwitchHomePageType';

function LoggedHead (props) {
    const location = useLocation();
    const navigate = useNavigate();
    const payChildRef = useRef(null);
    const couponChildRef = useRef()
    const { globalUser, globalBalance, setHasToken, setGlobaluser, } = useContext(AppContext);
    const [open, setOpen] = useState(false)
    const [powerBalance, setPowerBalance] = useState(globalBalance)

    useEffect(() => {
        setPowerBalance(globalBalance)
    }, [globalBalance])

    // 用来检查是否有虹豆/套餐到期需要提醒
    useEffect(() => {
        eventBus.emit('updateOrderList')
    }, [])
    
    // 多账号登录时更新账号信息
    useEffect(() => {
        eventBus.emit('updateUserInfo')
        eventBus.emit('updatePower')
        eventBus.emit('updateActivityInfo')
    }, [location])

    const goPerson = () => {
        window.open("/home/homemain/personalCenter", "_blank");

        // navigate("/home/homemain/personalCenter")
        setOpen(false)
    }

    const goBack = () => {
        if (location.pathname == "/home/homemain/requirement") {
            eventBus.emit('requirementForm:edited', () => {
                API.logout({}).then(res => {
                    navigate('/')
                    setGlobaluser()
                    localStorage.removeItem('token')
                    sessionStorage.removeItem('taskCache_model')
                    sessionStorage.removeItem('taskCache_dressform')
                    sessionStorage.removeItem('taskCache_clothes')
                    sessionStorage.removeItem('taskCache_commodity')
                    sessionStorage.removeItem('taskCache_tryonVideo')
                    sessionStorage.removeItem('taskCache_commodityVideo')
                    localStorage.removeItem('channel')
                    setHasToken(false)
                    setOpen(false)
                }).catch((error) => {
                    navigate('/')
                    localStorage.removeItem('token')
                    sessionStorage.removeItem('taskCache_model')
                    sessionStorage.removeItem('taskCache_dressform')
                    sessionStorage.removeItem('taskCache_clothes')
                    sessionStorage.removeItem('taskCache_commodity')
                    sessionStorage.removeItem('taskCache_tryonVideo')
                    sessionStorage.removeItem('taskCache_commodityVideo')
                    localStorage.removeItem('channel')
                    setHasToken(false)
                })
            })
            return
        }
        API.logout({}).then(res => {
            navigate('/')
            setGlobaluser()
            localStorage.removeItem('token')
            sessionStorage.removeItem('taskCache_model')
            sessionStorage.removeItem('taskCache_dressform')
            sessionStorage.removeItem('taskCache_clothes')
            sessionStorage.removeItem('taskCache_commodity')
            sessionStorage.removeItem('taskCache_tryonVideo')
            sessionStorage.removeItem('taskCache_commodityVideo')
            localStorage.removeItem('channel')
            setHasToken(false)
            setOpen(false)
        }).catch((error) => {
            navigate('/')
            localStorage.removeItem('token')
            sessionStorage.removeItem('taskCache_model')
            sessionStorage.removeItem('taskCache_dressform')
            sessionStorage.removeItem('taskCache_clothes')
            sessionStorage.removeItem('taskCache_commodity')
            sessionStorage.removeItem('taskCache_tryonVideo')
            sessionStorage.removeItem('taskCache_commodityVideo')
            localStorage.removeItem('channel')
            setHasToken(false)
        })
    }
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen)
        if(newOpen) {
            eventBus.emit('updateUserInfo')
            eventBus.emit('updatePower')
            eventBus.emit('updateActivityInfo')
        }
    }

    const content = (
        <div className='popover_box'>
            {
                globalUser?<div>
                    <div className={styles.popover_box_}>
                        <div className={styles.popover_box_top}>
                            <img className={styles.img1} src={require('@assets/images/icon_Avatar.png')} alt="" />
                            <ul>
                                <li className={styles.li1}>{globalUser?.mobile ? globalUser?.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : globalUser?.email}</li>
                            </ul>
                        </div>
                        <p className={styles.balance_p}><span>剩余金额</span><span>￥ {globalBalance}</span></p>
                        {/* <Progress percent={Math.ceil(globalUser?.membership?.balance/ globalUser?.membership?.amount) * 100} showInfo={false} /> */}
                      
                                {/* <p className={styles.coupon_p} onClick={openCouponClick}>我的优惠券</p> */}
                        <p className={styles.center_p} onClick={goPerson}>个人中心</p>
                        <p className={styles.logout_p} onClick={goBack}>退出登录</p>
                    </div>
                </div>: null
            }
        </div>
    );

    const [startBalance, setStartBalance] = useState(0)
    const [endBalance, setEndBalance] = useState(0)
    const endBalanceRef = useRef(0)

    useEffect(() => {
        endBalanceRef.current = powerBalance
        setEndBalance(powerBalance)
    }, [powerBalance])

    const countUpEnd = () => {
        setStartBalance(endBalanceRef.current)
    }

    return (
         <div className={styles.LoggedHead}>
            <div></div>
            <div style={{display: 'flex'}}>
                <div className={styles.LoggedHead_power}>
                    <span className={styles.LoggedHead_powerAmount}>{<CountUp start={startBalance} end={endBalance} separator=","  onEnd={countUpEnd}/>}</span>
                </div>
                {
                    <Popover
                        overlayClassName='person_popover'
                        placement="bottomRight"
                        content={content}
                        trigger="click"
                        onOpenChange={handleOpenChange}
                        open={open}
                    >
                        <img className={styles.LoggedHead_photo} onClick={() => setOpen(true)} src={require('@assets/images/icon_Avatar.png')} alt="" />
                    </Popover>
                }
            </div>
        </div>
       
    )
}

export default LoggedHead